import type { InferenceDataSourceDeclaration } from '@de/providers/DataSourceManager.types';
import {
  buildInferenceRequest,
  fetchInferenceDataSource,
} from '../fetchInferenceDataSource';
import type { DataSourceTypeDescriptor } from '../source-type-registry';

/**
 * A generation request against a host-supplied inference endpoint. The body is
 * opaque and interpolated; nothing here reads reporting vocabulary.
 */
export const inferenceSourceType: DataSourceTypeDescriptor<InferenceDataSourceDeclaration> =
  {
    kind: 'inference',

    buildRequest(decl, context, host) {
      return buildInferenceRequest(decl, context, host.inferenceUrl);
    },

    fetch(request, decl, options) {
      return fetchInferenceDataSource(decl, undefined, {
        ...options,
        preparedRequest: request,
      });
    },

    isSupported() {
      return true;
    },

    interpolatableFields(decl) {
      return [decl.body, decl.headers];
    },

    /**
     * A generation is billable, so an explicitly-triggered source stays
     * pending until something imperatively asks for it. Mount and
     * `formState`-change paths never force, so they never spend.
     */
    deferUntilForced(decl) {
      return (decl.trigger ?? 'auto') === 'explicit';
    },
  };
